import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { FiHeart } from 'react-icons/fi';
import { FaHeart } from 'react-icons/fa';

import { useAuth } from '../../hooks/auth';
import { useFavorites } from '../../hooks/favorites';

import Container from './styles';

const propTypes = {
  projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  size: PropTypes.oneOf(['sm', 'md']),
};

const defaultProps = {
  size: 'sm',
};

/* Um pouco acima da mais longa das duas animações (0.5s). */
const BURST_DURATION = 520;

const FavoriteButton = ({ projectId, size }) => {
  const history = useHistory();
  const { isLoggedIn } = useAuth();
  const { isFavorite, toggleFavorite } = useFavorites();
  // Animar por estado faria todos os corações já salvos pularem ao carregar a
  // página; o burst só existe a partir do clique.
  const [burst, setBurst] = useState(false);

  const active = isFavorite(projectId);
  const label = active ? 'Remover dos favoritos' : 'Salvar nos favoritos';

  useEffect(() => {
    if (!burst) return undefined;

    const timer = setTimeout(() => setBurst(false), BURST_DURATION);
    return () => clearTimeout(timer);
  }, [burst]);

  function handleClick(event) {
    // O botão vive dentro de cards clicáveis: o clique não pode abrir o projeto.
    event.preventDefault();
    event.stopPropagation();

    // Mesmo fluxo de autenticação do resto do portal.
    if (!isLoggedIn) {
      history.push('/login');
      return;
    }

    // Só ao salvar. Desfavoritar zera o burst, o que permite reanimar caso o
    // usuário clique de novo antes do timer terminar.
    setBurst(!active);

    toggleFavorite(projectId);
  }

  return (
    <Container
      type="button"
      size={size}
      active={active ? 1 : 0}
      burst={burst ? 1 : 0}
      onClick={handleClick}
      aria-pressed={active}
      aria-label={label}
      title={label}
    >
      {active ? (
        <FaHeart size={size === 'md' ? 20 : 16} />
      ) : (
        <FiHeart size={size === 'md' ? 20 : 16} />
      )}
    </Container>
  );
};

FavoriteButton.propTypes = propTypes;
FavoriteButton.defaultProps = defaultProps;

export default FavoriteButton;
